/** Canonical frontend roles (must match backend AppRoles). */
export const AppRoles = {
  Customer: 'customer',
  Vendor: 'vendor',
  Courier: 'courier',
  SuperAdmin: 'super_admin',
  Admin: 'admin',
  Support: 'support',
  Marketer: 'marketer',
} as const;

export type AppRole = (typeof AppRoles)[keyof typeof AppRoles];

export function isSuperAdmin(role?: string | null) {
  return role === AppRoles.SuperAdmin || role === AppRoles.Admin;
}

export function homePathForRole(role?: string | null): string {
  switch ((role || '').toLowerCase()) {
    case AppRoles.SuperAdmin:
    case AppRoles.Admin:
      return '/admin';
    case AppRoles.Support:
      return '/support';
    case AppRoles.Marketer:
      return '/marketer';
    case AppRoles.Vendor:
      return '/vendor';
    case AppRoles.Courier:
      return '/courier';
    default:
      return '/';
  }
}
